export default __webpack_public_path__ + "static/icons-insultation-2f64e373d8352aa5f07853d8d5c572b5.png";